import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SettingsService } from '@app/shared/services/settings/settings.service';
import { filter, switchMap, tap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-magic-link-login',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss'],
})
export class ConfirmEmailComponent implements OnInit {
  error: string;
  token: string;
  loading: boolean = true;
  title: string;
  content: string;

  constructor(
    private route: ActivatedRoute,
    private settingService: SettingsService
  ) {}

  ngOnInit() {
    this.route.params
      .pipe(
        tap((params) => {
          this.token = params['token'];
          if (!this.token) {
            this.loading = false;
            this.setError('No token was provided. Check the URL.');
          }
        }),
        filter((params) => Boolean(params['token'])),
        switchMap((params) => this.settingService.confirmEmail(params['token']))
      )
      .subscribe({
        next: this.confirmEmailSuccess.bind(this),
        error: this.confirmEmailError.bind(this),
      });
  }

  private confirmEmailSuccess() {
    this.loading = false;
    this.setSuccess('Your email address has been updated.');
  }

  private confirmEmailError(err: any) {
    this.loading = false;

    if (err.status === 400 && err.error?.reason === 'expired') {
      this.setError('Please request the email change again from your personal info settings.', 'Expired link');
      return;
    }

    this.setError('This link is not valid.');
  }

  private setError(error: string, title = 'Oops!') {
    this.title = title;
    this.error = error;
  }

  private setSuccess(content: string, title = 'Success!') {
    this.title = title;
    this.content = content;
    this.error = null;
  }
}
